import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-studio-simple',
    templateUrl: './studio-simple.component.html',
    styleUrls: ['./studio-simple.component.scss']
})
export class StudioSimpleComponent implements OnInit {

    @Input() studio;

    constructor() {
    }

    ngOnInit(): void {
    }

}
